import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiscord, faInstagram, faMastodon, faTiktok, faTwitch, faXTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';
import config from '../config.json';

type FooterProps = {
  isPavilionMode?: boolean;
};

export const Footer = ({ isPavilionMode = false }: FooterProps) => {
  return (
    <footer className='border-footer-border bg-footer text-footer-text m-0 grid grid-cols-12 border-t-2 px-4 py-8'>
      <nav id='social' className='col-span-full gap-x-2 p-2 md:col-span-5'>
        <ul className='flex h-min flex-row justify-center gap-x-4 align-middle md:justify-start lg:gap-x-8'>
          <li>
            <Link target='_blank' to={config.DISCORD_URL} aria-label='Discord'>
              <FontAwesomeIcon
                icon={faDiscord}
                className='text-footer-text hover:text-footer-hover focus:text-footer-hover active:text-footer-active pt-3 text-xl'
              />
            </Link>
          </li>
          <li>
            <Link target='_blank' to={config.YOUTUBE_URL} aria-label='YouTube'>
              <FontAwesomeIcon
                icon={faYoutube}
                className='text-footer-text hover:text-footer-hover focus:text-footer-hover active:text-footer-active pt-3 text-xl'
              />
            </Link>
          </li>
          <li>
            <Link target='_blank' to={config.TWITCH_URL} aria-label='Twitch'>
              <FontAwesomeIcon
                icon={faTwitch}
                className='text-footer-text hover:text-footer-hover focus:text-footer-hover active:text-footer-active pt-3 text-xl'
              />
            </Link>
          </li>
          <li>
            <Link target='_blank' to={config.TWITTER_URL} aria-label='Twitter'>
              <FontAwesomeIcon
                icon={faXTwitter}
                className='text-footer-text hover:text-footer-hover focus:text-footer-hover active:text-footer-active pt-3 text-xl'
              />
            </Link>
          </li>
          <li>
            <Link target='_blank' to={config.TIKTOK_URL} aria-label='TikTok'>
              <FontAwesomeIcon
                icon={faTiktok}
                className='text-footer-text hover:text-footer-hover focus:text-footer-hover active:text-footer-active pt-3 text-xl'
              />
            </Link>
          </li>
          <li>
            <Link target='_blank' to={config.INSTAGRAM_URL} aria-label='Instagram'>
              <FontAwesomeIcon
                icon={faInstagram}
                className='text-footer-text hover:text-footer-hover focus:text-footer-hover active:text-footer-active pt-3 text-xl'
              />
            </Link>
          </li>
        </ul>
      </nav>
      <nav id='legal' className='col-span-full gap-x-2 p-2 md:col-span-7'>
        <ul className='flex h-min flex-row justify-center gap-x-4 align-middle md:justify-end md:gap-x-8'>
          <li className='hover:text-footer-hover focus:text-footer-hover active:text-footer-active'>
            <Link to='/privacy-policy'>
              Privacy Policy
            </Link>
          </li>
          <li className='hover:text-footer-hover focus:text-footer-hover active:text-footer-active'>
            <Link to='/terms-of-service'>
              Terms of Service
            </Link>
          </li>
          <li className='hover:text-footer-hover focus:text-footer-hover active:text-footer-active'>
            <Link to='/eula'>
              EULA
            </Link>
          </li>
          <li>
            <Link to='/about-us'>
              &copy; {new Date().getFullYear()} Playcast, Inc.
            </Link>
          </li>
          {/* <li className='hover:text-footer-hover focus:text-footer-hover active:text-footer-active'>
            <Link to='/sitemap.xml'>Sitemap</Link>
          </li> */}
        </ul>
      </nav>
    </footer>
  );
};
